var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welfare-page"},[(_vm.isWelfareLoading)?_c('om-loading',{attrs:{"visable":_vm.isWelfareLoading,"type":"whole","theme":"blue"}}):(_vm.isWelfareError)?_c('mui-errorloading'):_c('welfare-content',{ref:"welfareContent"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }